module.exports = __webpack_public_path__ + "static/media/slingshot_cocking_1.454e3b60.mp3";